import { Component, OnInit, Input, HostListener, ElementRef, Output, EventEmitter } from '@angular/core';

import { Inject } from "@angular/core";
import { DOCUMENT } from '@angular/platform-browser';

import { LanguageService } from '../../services';

@Component({
  selector: 'banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent implements OnInit {

  resize: boolean = false;

  english: boolean;

  @Input()
  slogan: string;

  @Output()
  language = new EventEmitter<boolean>();


  // ***************************** //

  constructor(
    @Inject(DOCUMENT)
    private document: Document,
    private languageService: LanguageService) { }

  ngOnInit() {
    this.getLanguage();
  }

  getLanguage() {
    this.languageService.getLanguage()
      .subscribe(english => this.english = english);
  }

  setFrench() {
    this.languageService.setFrench();
    this.language.emit(false);
    this.english = false;
  }

  setEnglish() {
    this.languageService.setEnglish();
    this.language.emit(true);
    this.english = true;
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll($event) {
    if (window.scrollY > window.innerHeight) {
      this.resize = true;
    } else {
      this.resize = false;
    }
  }
}
